import { render, staticRenderFns } from "./ClosingStatementPdf.vue?vue&type=template&id=5532df04&"
import script from "./ClosingStatementPdf.vue?vue&type=script&lang=js&"
export * from "./ClosingStatementPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports